const TopBar = () => {
  return (
    <div className="w-full hidden md:block py-1  font-ovo  text-[0.8rem] sm:text-[0.9rem] text-center bg-[#08131A] text-[#FFFFFF]">
      Educate to inspire, Enable to achieve, Engage to grow.
    </div>
  );
};

export default TopBar;
